// This is exportable for tests
export const TOKEN_KEY = "TOKEN"

export function saveToken(token: string) {
  if (token.length === 0) {
    clearLocalStorageToken()
  } else {
    localStorage.setItem(TOKEN_KEY, token)
  }
}

export function loadToken(): string | null {
  if (typeof window === "undefined") {
    return null
  }
  return localStorage.getItem(TOKEN_KEY)
}

export function clearLocalStorageToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function isAuthenticated(): boolean {
  return loadToken() !== null
}
